<template>
  <modal
    title="Modifier le mot de passe"
    @close="cancel()">

    <div class="password-change">
      <div v-if="message !== null"
           v-bind:class="'callout callout-'+message.type">
        <p>{{ message.text }}</p>
      </div>
      <div>
        <label>Nouveau mot de passe</label>
        <input type="password" length="4" class="form-control" v-model="newPassword"/>
        <div class="error-message">
          {{ this.passwordValidationMessage }}
        </div>
      </div>
      <div class="security">
        Pour des mesures de sécurité, nous vous demandons de resaisir votre nom d'utilisateur et mot de passe. Merci
        pour votre compréhension
      </div>
      <div class="row">
        <div class="col-sm-6">
          <label>Votre login</label>
          <input type="text" class="form-control" v-model="challengedUsername"/>
        </div>
        <div class="col-sm-6">
          <label>Votre mot de passe</label>
          <input type="password" length="4" class="form-control" v-model="challengedPassword"/>
        </div>
      </div>
      <div class="buttons">
        <div class="btn btn-default" @click="cancel()" v-if="!canOnlyExitModal">Annuler</div>
        <div class="btn btn-primary" @click="ok()" v-if="!canOnlyExitModal">Modifier</div>
      </div>
      <div class="loading-overlay" v-if="isLoading">
        Chargement ...
      </div>
    </div>

  </modal>
</template>

<script>
import Modal from '../modals/ModalBasic.vue'

export default {
  props: [
    'canOnlyExitModal',
    'changeDispatchAction',
    'isLoading',
    'hideDispatchAction',
    'message',
    'selectedPerson',
    'title',
  ],
  components: {
    Modal,
  },
  data: function () {
    return {
      newPassword: '',
      challengedUsername: '',
      challengedPassword: '',
      passwordValidationMessage: '',
    }
  },
  methods: {
    cancel: function () {
      this.$store.dispatch(this.hideDispatchAction)
    },
    ok: function () {
      if (this.validatePassword()) {
        console.log('dayza ::: ', this.selectedPerson)

        if (this.selectedPerson.profile) {
          this.$store.dispatch('changePasswordAgentV2', {
            login: this.challengedUsername,
            password: this.challengedPassword,
            idAgent: this.selectedPerson.id,
            newPassword: this.newPassword
          })
        } else {
          this.$store.dispatch('changePasswordAdministratorV2', {
            login: this.challengedUsername,
            password: this.challengedPassword,
            idAdmin: this.selectedPerson.id,
            newPassword: this.newPassword
          })
        }

      }
    },
    validatePassword () {
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}$/

      if (!passwordRegex.test(this.newPassword)) {
        this.passwordValidationMessage =
          'Le mot de passe doit contenir au moins 8 caractères, dont une lettre minuscule, une lettre majuscule, un chiffre et un caractère spécial (@$!%*?&).'
        return false
      } else {
        this.passwordValidationMessage = ''
        return true
      }
    },
  },
}
</script>

<style lang="scss">
.password-change {
  max-width: 400px;

  .security {
    padding: 5rem;
    text-align: center;
  }
}
.error-message {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ChangePasswordModal.vue?397e86c6